export const center_app_version = {"commit_sha": "60c6786a"}
